import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() totalPages: number | undefined;
  @Output() nextClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() backClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() currentPage = 1;

  constructor() { }

  ngOnInit() {
  }

  onNextBtnClicked() {
    this.nextClicked.emit(true);
  }

  onBackClicked() {
    this.backClicked.emit(true);
  }
}
